module.exports = __webpack_public_path__ + "static/media/75_brushed_silver_metal_seamless.c1f903aa.jpg";